import { createFileRoute } from '@tanstack/react-router';
import { AiSettingsPanel } from '@/components/ai/ai-settings';

export const Route = createFileRoute('/_app/account/ai')({ component: AiSettingsPanel });
